<router-outlet></router-outlet>
<router-outlet name="admin"></router-outlet>
